import { Badge } from "./badge";

export class RouteChild {
    id: number;
    url: string;
    name: string;
    roleId: string;
    routeId: number;
    icon: string;
    active: boolean;
    variant: string;
    class: string;
    badge: Badge;
    position: number;
    state: any;


    constructor(id: number, url: string, name: string, roleId: string, routeId: number) {
        this.id = id;
        this.url = url;
        this.name = name;
        this.roleId = roleId;
        this.routeId = routeId;

    }
}
